/**
 * Lightweight "recently viewed" store (localStorage). Used by the command
 * palette to surface the clients and outputs a user last opened. Best-effort —
 * never throws, no-ops if storage is unavailable (e.g. private mode / quota).
 *
 * Note: stores only non-sensitive navigation breadcrumbs ({type, id, title,
 * path, badge}) — no tokens, credentials or PII — so localStorage is appropriate.
 */
import { logger } from "@/lib/logger";

const KEY = "daakyi:recents";
const MAX = 6;

export function getRecents() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(list) ? list : [];
  } catch (e) {
    logger.debug("recents: could not read store", e);
    return [];
  }
}

export function pushRecent(item) {
  if (!item?.id || !item?.path || !item?.type) return;
  try {
    const next = [
      { ...item, ts: Date.now() },
      ...getRecents().filter((r) => !(r.type === item.type && r.id === item.id)),
    ].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {
    logger.debug("recents: could not write store", e);
  }
}
